
<button kendoButton [primary]="true" [svgIcon]="clockArrowRotateIcon" [title]="'Audit history'" type="submit" (click)="openDialog()">Log</button>
<ng-container *ngIf="isDialogOpen">
    <kendo-dialog [height]="'80%'" [width]="'80%'" resizable="true" (close)="closeDialog()">
      <kendo-dialog-titlebar>
        Audit Log
      </kendo-dialog-titlebar>
        <nexus-grid [data]="model" [sort]="[{ 'field': 'date_created', 'dir': 'desc' }]" class="container">
          <kendo-grid-span-column>
            <kendo-grid-column  class="container" field="date_created" title="Date" [width]="150" format="G" filter="date"></kendo-grid-column>
            <kendo-grid-column field="action_type.name" title="Type" [width]="150"></kendo-grid-column>
            <kendo-grid-column field="user.name" title="User" [width]="150"></kendo-grid-column>
            <kendo-grid-column field="user.title" title="Title" [width]="150"></kendo-grid-column>
            <kendo-grid-column field="audit_source" title="Source" [width]="150"></kendo-grid-column>
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="container">
                <h3><strong>{{ replaceUnderscore(dataItem.action_type.name) | titlecase }}</strong></h3>
                <h6>{{ dataItem.date_created | kendoDate: 'G' }}</h6>
                <h6>{{ dataItem.user?.name }}</h6>
                <h6>{{ dataItem.user?.title }}</h6>
                <h6 *ngIf="dataItem.audit_source">{{ dataItem.audit_source }}</h6>

              </div>

            </ng-template>
          </kendo-grid-span-column>
          <kendo-grid-column field="meta" title="Meta">

            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="container">
              <ul *ngIf="dataItem.meta">
                <li *ngFor="let key of getKeys(dataItem.meta)">
                  <strong>{{ replaceUnderscore(key) | titlecase }}</strong>: <span class="pre-wrap-inline-flex" [innerHTML]="replaceHTMLTags(dataItem?.meta[key])"></span>
                </li>
              </ul>
            </div>
            </ng-template>
          </kendo-grid-column>

        </nexus-grid>
    </kendo-dialog>

</ng-container>










